var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmailSent = function SvgEmailSent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 162 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.934 2.4.794 47.331v99.871a8 8 0 0 0 8 8h144.412a8 8 0 0 0 8-8V47.332L85.066 2.399a8 8 0 0 0-8.132 0Z",
    stroke: "#EE9000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.794 46.846v100.357a8 8 0 0 0 8 8H130.63c6.81 0 9.61-8.737 4.069-12.696L.794 46.846Z",
    fill: "url(#email-sent_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.206 46.846v100.357a8 8 0 0 1-8 8H19.059L161.206 46.846Z",
    fill: "#EE9000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.995 116.855a21.036 21.036 0 0 0 4.541 13.08l-12.25 11.131a3.198 3.198 0 0 0-.107 4.631l1.019 1.013a3.21 3.21 0 0 0 1.079.709 3.242 3.242 0 0 0 3.577-.814l11.31-12.33a21.254 21.254 0 0 0 11.105 3.742v-7.797a13.493 13.493 0 0 1-8.852-4.256 13.375 13.375 0 0 1-3.588-9.11c0-3.377 1.282-6.631 3.588-9.109a13.499 13.499 0 0 1 8.852-4.257v-7.797a21.34 21.34 0 0 0-14.393 6.544 21.143 21.143 0 0 0-5.881 14.62Zm-4.314 27.863a1.5 1.5 0 0 1-1.383-.919 1.481 1.481 0 0 1 .324-1.623 1.497 1.497 0 0 1 2.555 1.053c0 .395-.157.774-.438 1.053a1.5 1.5 0 0 1-1.058.436ZM127.3 95.69v7.797a13.518 13.518 0 0 1 6.889 2.513 13.424 13.424 0 0 1 4.547 5.731l7.225-2.978a21.223 21.223 0 0 0-7.425-9.227A21.368 21.368 0 0 0 127.3 95.69ZM138.732 121.986a13.418 13.418 0 0 1-4.546 5.727 13.525 13.525 0 0 1-6.886 2.509v7.797a21.368 21.368 0 0 0 11.232-3.83 21.221 21.221 0 0 0 7.426-9.219l-7.223-2.975-.003-.009Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "email-sent_svg__a",
    x1: 0.794,
    y1: 46.672,
    x2: 111.946,
    y2: 171.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE9000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
};
export default SvgEmailSent;